import { post } from '../../base';

export function shipping(orderId: string, payload: any) {
  return post(`v3/merchants/orders/${orderId}/shipping`, { json: payload }).json();
}
